module.exports = __webpack_public_path__ + "img/L.435b2c97.jpg";